import { ExperienceTransferTranslation, queryFilters } from 'app/area/experience-transfer/constants';
import { ComplexValue } from 'app/types-shared';
import { allPredefinedFilters, fieldType } from "app/area/search-filters/constants";
import {
  CustomFilterType, Filter, FilterCommonValues, FilterType,
  PredefinedFilter, PredefinedFilterType, PredefinedIds
} from "app/area/search-filters/filters/types";
import { filterId } from 'app/area/experience-transfer/list/constants';
import { endpoints } from 'app/area/experience-transfer/list/endpoints';

export const experienceTransferQueryFilters = (translation: ExperienceTransferTranslation): ComplexValue<string>[] => [
  { value: queryFilters.subscriberGroup, description: translation.subscriber_group },
  { value: queryFilters.criteria, description: translation.criteria }
];

export const experienceTransferPredefinedFilters = (translation: ExperienceTransferTranslation): PredefinedFilter => ({
  type: PredefinedFilterType.code,
  values: [
    { value: allPredefinedFilters.excludeInactiveCodes, description: translation.hide_inactive }
  ]
});

export const experienceTransferFilters = (
  translation: ExperienceTransferTranslation
): Filter[] => [
  {
    id: filterId.application,
    label: translation.case_type,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.code,
        optionsEndpoint: endpoints.caseTypeOptions,
        optionsParams: { displayNotSelected: true }
      }
    ],
    type: FilterType.SELECTED_IDS
  },
  {
    id: filterId.operation,
    label: translation.operation,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.code,
        optionsEndpoint: endpoints.operationOptions,
        optionsParams: { displayNotSelected: true }
      }
    ],
    type: FilterType.SELECTED_IDS
  }
].filter(filter => !!filter);

export const experienceTransferDefaultFilters = (
  translation: ExperienceTransferTranslation
): { [key: string]: FilterCommonValues<number>[] } => ({
  [PredefinedIds.include]: [
    { value: allPredefinedFilters.excludeInactiveCodes, description: translation.hide_inactive }
  ]
});
